// extracted by mini-css-extract-plugin
export default {"empty-arc-tags":"EmptyArcTags_empty-arc-tags__pOmqa"};